// ROO2-283: the Columns choice of a BI report, kept in the user account as the list of every block of the report in table
// order with its visibility (D22, D24). The page shows the blocks in table order, whatever the order of the saved list.

// D7: the same block ids in every BI report; a report shows only the blocks that it has. Segmentation's today and the three
// blocks of Room types (STLY, LY actual, Δ%) are blocks of that report only.
export type ColumnBlock = 'build' | 'today' | 'ly' | 'stly' | 'lyActual' | 'vs'
	| 'd1' | 'd3' | 'd7' | 'd14' | 'd30' | 'pu1' | 'pu3' | 'pu7' | 'pu14' | 'pu30';

export type SavedColumn = { id: string, visible: boolean };

// B3: an id that the report does not know is ignored; a block that the list does not hold takes its default.
export const chosenOf = <T extends string>(saved: SavedColumn[] | null, blocks: readonly T[], defaults: readonly T[]): T[] =>
	blocks.filter(block => {
		const column = saved?.find(c => c.id === block);
		return column === undefined ? defaults.includes(block) : column.visible;
	});

export const listOf = <T extends string>(chosen: readonly T[], blocks: readonly T[]): SavedColumn[] =>
	blocks.map(id => ({ id, visible: chosen.includes(id) }));

export const toggled = <T extends string>(chosen: readonly T[], block: T, blocks: readonly T[]): T[] =>
	blocks.filter(x => x === block ? !chosen.includes(x) : chosen.includes(x));

// The choice that a browser holds from before ROO2-283 (Rate plans, Guest Mix): a JSON list of the shown blocks. null when
// there is none or it is not a list of blocks of the report.
export const legacyOf = <T extends string>(raw: string | null, blocks: readonly T[]): T[] | null => {
	if (raw === null) return null;
	try {
		const value: unknown = JSON.parse(raw);
		if (!Array.isArray(value) || !value.every(x => blocks.includes(x as T))) return null;
		return blocks.filter(block => value.includes(block));
	} catch {
		return null;
	}
};
